// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { WidgetChartTypeEnum, WidgetCounterOutput } from 'thehive-sdk';
import NewWidgetDrawer from '@Organisms/Dashboard/WidgetManage/NewWidgetDrawer';
import { CounterValues, CounterForm } from '@Organisms/Dashboard/WidgetManage/Counter/CounterForm';

export const getNewCounterWidget = (counter: CounterValues): WidgetCounterOutput => {
    const { title, entity, series = [], filters = [], periodDateField } = counter;

    return {
        type: WidgetChartTypeEnum.counter,
        options: {
            title,
            entity,
            query: {},
            series,
            filters,
            periodDateField,
        },
        id: '',
    };
};

const NewCounterDrawer = (): ReactElement => (
    <NewWidgetDrawer
        getNewWidget={(values) => getNewCounterWidget(values as CounterValues)}
        WidgetForm={CounterForm}
        widgetType="counter"
    />
);

export default NewCounterDrawer;
